import { VipMessaging as SharedUiVipMessaging } from "@shared-ui/lodging-property-offers";
import { PropertyBexApiWrapper } from "components/shared/BexApiWrapper/PropertyBexApiWrapper";

const VipMessaging = PropertyBexApiWrapper(SharedUiVipMessaging);
export default VipMessaging;
